export default __webpack_public_path__ + "static/media/Archive.f01e4aef.svg";